import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Grid } from 'syf-component-library/ui/patterns';
import { Inset } from 'syf-component-library/ui/spacing';
const MessageContainer = styled(Grid) `
  display: flex;
  justify-content: center;
  text-align: center;
`;
const ManageAutopayMessage = ({ message }) => {
    return (_jsx(MessageContainer, Object.assign({ container: true }, { children: _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Inset, Object.assign({ "data-cy": "autopay-modification-message", horizontal: "large", vertical: "xlarge" }, { children: message })) })) })));
};
export default ManageAutopayMessage;
